import React, { useState } from 'react';
import { Button, Upload, Modal, message, Typography, Space } from 'antd';
import { ArrowLeftOutlined, InboxOutlined, UploadOutlined, DownloadOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import axios from '../../../API/config';
import './ProjectManagement.css';
import ProjectsList from './ProjectsList';
import { ROUTES } from '../../../Util/routes';

const ProjectManagement = () => {
    const history = useHistory();
    const [uploadModalVisible, setUploadModalVisible] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadLoading, setUploadLoading] = useState(false);

    const handleBack = () => {
        history.goBack();
    };

    const navigateToProjectOnboarding = () => {
        history.push(ROUTES.PROJECT_ONBOARDING);
    };
    const closeUploadModal = () => {
        setUploadModalVisible(false);
        setSelectedFile(null);
    };

    const handleFileSelect = (info) => {
        const file = info.file;
        const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
            file.type === 'application/vnd.ms-excel' ||
            file.name.endsWith('.xlsx') ||
            file.name.endsWith('.xls');
        if (!isExcel) {
            message.error('Please select an Excel file (.xlsx or .xls)');
            return;
        }
        setSelectedFile(file);
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            message.error('Please select a file to upload');
            return;
        }
        try {
            setUploadLoading(true);
            const formData = new FormData();
            formData.append('excel_file', selectedFile, selectedFile.name);
            const response = await axios.post('/project-onboarding/upload', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.status === 200 || response.status === 201) {
                message.success('File uploaded successfully! Processing started.');
                closeUploadModal();
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Upload failed';
            message.error(errorMessage);
        } finally {
            setUploadLoading(false);
        }
    };


    const { Title, Paragraph } = Typography;

    return (
        <div className="project-management-container">
                <Button type="text" icon={<ArrowLeftOutlined />} className="ActionBar-backButton" onClick={handleBack}>
                   <span className="ActionBar-backButton-text">Back</span>
                </Button>

            <div style={{ padding: 12 }}>
                <div className="section-header">
                    <div className="header-content">
                        <Title level={3} style={{ marginBottom: 4 }}>Project Management</Title>
                        <Paragraph type="secondary" style={{ margin: 0 }}>
                            View and manage projects. Use the button to add via Excel upload.
                        </Paragraph>
                    </div>
                    <div className="project-management-header-buttons">
                        <Button type="primary" onClick={navigateToProjectOnboarding}>
                            Project onboarding
                        </Button>
                        {/* <Button icon={<DownloadOutlined />} onClick={handleDownloadTemplate}>
                            Download Template
                        </Button> */}
                    </div>
                </div>
                <ProjectsList />
            </div>

            <Modal
                title="Upload Project Onboarding File"
                open={uploadModalVisible}
                onOk={handleUpload}
                onCancel={closeUploadModal}
                okText="Upload"
                cancelText="Cancel"
                okButtonProps={{ type: 'primary', disabled: !selectedFile, loading: uploadLoading }}
                width={520}
                className="upload-modal"
            >
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                    <Upload.Dragger
                        name="excel_file"
                        multiple={false}
                        accept=".xlsx,.xls"
                        beforeUpload={() => false}
                        onChange={handleFileSelect}
                        showUploadList={false}
                    >
                        <p className="ant-upload-drag-icon">
                            <InboxOutlined style={{ fontSize: 48, color: '#1890ff' }} />
                        </p>
                        <p className="ant-upload-text">
                            {selectedFile ? selectedFile.name : 'Click or drag Excel file to this area to upload'}
                        </p>
                        <p className="ant-upload-hint">
                            {selectedFile ? 'File selected successfully!' : 'Only Excel files (.xlsx, .xls) are allowed'}
                        </p>
                    </Upload.Dragger>
                    {selectedFile && (
                        <div className="file-selected-info">
                            <p>
                                <strong>Selected File:</strong> {selectedFile.name}
                            </p>
                            <p className="file-size">Size: {(selectedFile.size / 1024 / 1024).toFixed(2)} MB</p>
                        </div>
                    )}
                </div>
            </Modal>
        </div>
    );
};

export default ProjectManagement;